<style>
@import "../account.scss";
</style>

<script>
import countryCodes from '../../../data/countryCodes.json'
import ConsumerService from '../account-consumer.service'
import { mapGetters } from 'vuex'

const consumerService = new ConsumerService()

export default {
  name: 'ProfileManagement',
  components: {
  },
  data () {
    return {
      editMode: false,
      submitted: false,
      countryCodes: countryCodes,
      defaultConsumerInfo: '',
      consumerInformation: '',
      errorMessage: false,
      successMessage: false
    }
  },
  computed: {
    ...mapGetters(['consumerInfo', 'consumerJwt']),

    consumerInfo: {
      get () {
        return this.$store.state.configuration.consumerInfo || {}
      },
      set (value) {
        this.$store.commit('changeConsumerInfo', value)
      }
    }
  },
  watch: {
    consumerInfo: {
      handler () {
        this.setDefaultData()
      }
    }
  },
  created () {
    this.setDefaultData()
  },
  methods: {

    /**
     * This method will edit the consumer information
     */
    editInfo () {
      this.editMode = true
    },

    /**
     * This method will set consumer info again to default values on cancel
     */
    cancelEdit () {
      this.updateInfo(this.defaultConsumerInfo)
      this.editMode = false
    },

    /**
     * This method sets the default data for consumer
     */
    setDefaultData () {
      this.defaultConsumerInfo = Object.assign({}, this.consumerInfo)
      this.consumerInformation = Object.assign({}, this.consumerInfo)
    },

    /**
     * This method will update the consumer info
     * @param data
     */
    updateInfo (data) {
      this.consumerInfo = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: data.phoneNumber,
        userId: data.userId,
        startAccessJwt: this.consumerJwt,
        nationalIdentifier: data.nationalIdentifier,
        countryCode: data.countryCode
      }
    },

    /**
     * This method will handle the save functionality
     * @param e
     */
    handleSubmit (e) {
      this.submitted = true
      this.$validator.validate().then(valid => {
        if (valid) {
          this.updateInfo(this.consumerInformation)
          consumerService.register(this.consumerInformation).then(res => {
            this.editMode = false
            this.$store.commit('changeConsumerInfo', this.consumerInformation)
            this.setDefaultData()
            this.successMessage = 'Details updated successfully.'
            setTimeout(() => {
              this.successMessage = false
            }, 3000)
          }).catch(error => {
            this.errorMessage = error
            setTimeout(() => {
              this.errorMessage = false
            }, 3000)
          })
        }
      })
    }
  }
}
</script>

<template>
  <div
    id="profile-management"
  >
    <div
      class="row mt-4">
      <div class="col">
        <h3>
          {{ $t ('label.profile') }}
        </h3>
      </div>
    </div>
    <div class="border-dark border-top my-2" />
    <div class="mt-5 col-md-8 col-sm-12 mx-auto border-primary border px-0">
      <h4 class="border-primary border bg-primary text-white text-center py-2">
        {{ $t ('label.editProfile') }}
      </h4>
      <div
        v-if="successMessage"
        class="alert alert-primary mx-auto col-sm-12 col-md-10"
        role="alert"
      >
        {{ successMessage }}
      </div>
      <div
        v-if="errorMessage"
        class="alert alert-danger mx-auto col-sm-12 col-md-10"
        role="alert"
      >
        {{ errorMessage }}
      </div>
      <div class="src-user-icon my-5">
        <i class="fa fa-user-circle-o text-primary fa-5x" />
      </div>
      <div class="col-md-10 col-sm-12 mx-auto py-3">
        <form
          class="pb-3"
          @submit.prevent="handleSubmit">
          <div class="row mb-4">
            <h5 class="col-md-6 col-sm-12 text-md-right font-weight-bold">
              {{ $t ('label.consumerName') }}
            </h5>
            <div
              v-if="!editMode"
              class="col-md-6 col-sm-12 text-left">
              <span>{{ consumerInformation.firstName }} </span>
              <span>{{ consumerInformation.lastName }}</span>
            </div>
            <div
              v-else
              class="col-md-6 col-sm-12 mb-3">
              <div class="col-md-6 col-sm-12 pl-0 float-left">
                <input
                  v-validate="{ required: true, min: 2 }"
                  id="consumerFirstName"
                  v-model="consumerInformation.firstName"
                  :class="{ 'is-invalid': submitted && errors.has('firstName') }"
                  name="firstName"
                  placeholder="First name"
                  type="text"
                  class="form-control"
                >
                <div
                  v-if="submitted && errors.has('firstName')"
                  class="invalid-feedback">{{ errors.first('firstName') }}</div>
              </div>
              <div class="col-md-6 col-sm-12 pl-0 float-left">
                <input
                  v-validate="{ required: true, min: 2 }"
                  id="consumerLastName"
                  v-model="consumerInformation.lastName"
                  :class="{ 'is-invalid': submitted && errors.has('lastName') }"
                  name="lastName"
                  placeholder="Last name"
                  type="text"
                  class="form-control"
                >
                <div
                  v-if="submitted && errors.has('lastName')"
                  class="invalid-feedback">{{ errors.first('lastName') }}</div>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <h5 class="col-md-6 col-sm-12 text-md-right font-weight-bold">
              {{ $t ('label.consumerMobileNumber') }}
            </h5>
            <div
              v-if="!editMode"
              class="col-md-6 col-sm-12 text-left">
              <span v-if="consumerInformation.countryCode">
                {{ consumerInformation.countryCode.concat(' ',consumerInformation.phoneNumber) }}
              </span>
              <span v-else>{{ consumerInformation.phoneNumber }}</span>
            </div>
            <div
              v-else
              class="col-md-6 col-sm-12">
              <div class="col-md-6 col-sm-12 pl-0 float-left">
                <select
                  id="consumerCountryCode"
                  v-model="consumerInformation.countryCode"
                  class="form-control"
                  name="countryCode"
                >
                  <option
                    v-for="(codes,index) in countryCodes"
                    :key="index"
                    :value="codes.code +' '+ codes.dial_code"
                  >
                    <span v-if="codes">{{ codes.code.concat(" ", codes.dial_code) }}</span>
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-12 pl-0 float-left">
                <input
                  v-validate="{ required: true, digits: 10 }"
                  id="consumerPhoneNumber"
                  v-model="consumerInformation.phoneNumber"
                  :class="{ 'is-invalid': submitted && errors.has('phoneNumber') }"
                  name="phoneNumber"
                  placeholder="Phone number"
                  type="text"
                  class="form-control"
                >
                <div
                  v-if="submitted && errors.has('phoneNumber')"
                  class="invalid-feedback">{{ errors.first('phoneNumber') }}</div>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <h5 class="col-md-6 col-sm-12 text-md-right font-weight-bold">
              {{ $t ('label.consumerEmail') }}
            </h5>
            <div class="col-md-6 col-sm-12 text-left">
              {{ consumerInformation.email }}
            </div>
          </div>
          <div
            v-if="editMode"
            class="my-5 col-md-8 col-sm-12 mx-auto">
            <button
              class="btn btn-primary btn-block">
              {{ $t ('label.save') }}
            </button>
            <button
              class="btn border-primary text-primary btn-white btn-block"
              @click="cancelEdit()">
              {{ $t ('label.cancelEdit') }}
            </button>
          </div>
        </form>
        <div
          v-if="!editMode"
          class="my-5 col-md-8 col-sm-12 mx-auto">
          <button
            class="btn btn-primary btn-block"
            @click="editInfo()">
            {{ $t ('label.edit') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
